import { InfoCircle } from "@untitledui/icons";
import type React from "react";
import { Tooltip, TooltipTrigger } from "@/components/base/tooltip/tooltip";
import { cx } from "@/utils/cx";

interface MetricCardProps {
  title: string;
  value?: React.ReactNode;
  description: string;
  className?: string;
}

export const MetricCard: React.FC<MetricCardProps> = ({ title, value, description, className }) => {
  return (
    <div
      className={cx(
        "p-5 relative bg-secondary rounded-xl border border-secondary inline-flex flex-col justify-between items-start pr-12",
        className,
      )}
    >
      <div className="self-stretch justify-start text-tertiary text-sm font-medium">{title}</div>
      <div className="self-stretch inline-flex justify-start items-end gap-2 flex-wrap content-end">
        {value ? (
          <div className="flex-1 min-w-24 justify-start text-primary text-3xl font-semibold">{value}</div>
        ) : (
          <div className="h-8 w-32 animate-pulse rounded bg-gray-200" />
        )}
      </div>
      <Tooltip title={description}>
        <TooltipTrigger className="absolute top-5 right-5 cursor-pointer text-fg-disabled transition duration-100 ease-linear hover:text-fg-quaternary_hover focus:text-fg-quaternary_hover">
          <InfoCircle className="w-5 h-5" />
        </TooltipTrigger>
      </Tooltip>
    </div>
  );
};
